import { render, staticRenderFns } from "./ContainerHeader.vue?vue&type=template&id=45ac21b9&scoped=true&"
import script from "./ContainerHeader.vue?vue&type=script&lang=js&"
export * from "./ContainerHeader.vue?vue&type=script&lang=js&"
import style0 from "./ContainerHeader.vue?vue&type=style&index=0&id=45ac21b9&prod&lang=scss&scoped=true&"
import style1 from "./ContainerHeader.vue?vue&type=style&index=1&id=45ac21b9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ac21b9",
  null
  
)

export default component.exports
import {QHeader,QToolbar,QBtnDropdown,QMenu,QItem,QItemSection,QAvatar,QList,QIcon,QBtn,QSpace,QCard,QCardSection,QItemLabel,QDialog,QSeparator,QDrawer,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QHeader,QToolbar,QBtnDropdown,QMenu,QItem,QItemSection,QAvatar,QList,QIcon,QBtn,QSpace,QCard,QCardSection,QItemLabel,QDialog,QSeparator,QDrawer})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
